var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "vue-star-rating-star",
      attrs: {
        height: _vm.starSize,
        width: _vm.starSize,
        viewBox: _vm.viewBox
      },
      on: { mousemove: _vm.mouseMoving, click: _vm.selected }
    },
    [
      _c(
        "linearGradient",
        { attrs: { id: _vm.grad, x1: "0", x2: "100%", y1: "0", y2: "0" } },
        [
          _c("stop", {
            attrs: {
              offset: _vm.starFill,
              "stop-color": _vm.rtl
                ? _vm.getColor(_vm.inactiveColor)
                : _vm.getColor(_vm.activeColor),
              "stop-opacity": _vm.rtl
                ? _vm.getOpacity(_vm.inactiveColor)
                : _vm.getOpacity(_vm.activeColor)
            }
          }),
          _vm._v(" "),
          _c("stop", {
            attrs: {
              offset: _vm.starFill,
              "stop-color": _vm.rtl
                ? _vm.getColor(_vm.activeColor)
                : _vm.getColor(_vm.inactiveColor),
              "stop-opacity": _vm.rtl
                ? _vm.getOpacity(_vm.activeColor)
                : _vm.getOpacity(_vm.inactiveColor)
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "filter",
        {
          attrs: {
            id: _vm.glowId,
            height: "130%",
            width: "130%",
            filterUnits: "userSpaceOnUse"
          }
        },
        [
          _c("feGaussianBlur", {
            attrs: { stdDeviation: _vm.glow, result: "coloredBlur" }
          }),
          _vm._v(" "),
          _c(
            "feMerge",
            [
              _c("feMergeNode", { attrs: { in: "coloredBlur" } }),
              _vm._v(" "),
              _c("feMergeNode", { attrs: { in: "SourceGraphic" } })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.glowColor
        ? _c("polygon", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.fill > 1,
                expression: "fill > 1"
              }
            ],
            attrs: {
              points: _vm.starPointsToString,
              fill: _vm.gradId,
              stroke: _vm.glowColor,
              filter: "url(#" + _vm.glowId + ")"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("polygon", {
        attrs: {
          points: _vm.starPointsToString,
          fill: _vm.gradId,
          stroke: _vm.getBorderColor,
          "stroke-width": _vm.border,
          "stroke-linejoin": _vm.roundedCorners ? "round" : "miter"
        }
      }),
      _vm._v(" "),
      _c("polygon", {
        attrs: { points: _vm.starPointsToString, fill: _vm.gradId }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }